export type SessionRealm = 'admin' | 'user';

const SESSION_REALM_KEY = 'spence_session_realm';

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage?.getItem === 'function';
}

export function setSessionRealm(realm: SessionRealm): void {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.setItem(SESSION_REALM_KEY, realm);
}

export function getSessionRealm(): SessionRealm | null {
  if (!canUseStorage()) {
    return null;
  }

  const value = window.localStorage.getItem(SESSION_REALM_KEY);
  if (value === 'admin' || value === 'user') {
    return value;
  }

  return null;
}

export function clearSessionRealm(): void {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.removeItem(SESSION_REALM_KEY);
}
